import React from 'react';

export const SEARCH = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M13.1257 14.5597C11.7633 15.6266 10.0242 16.2701 8.13506 16.2701C3.64247 16.2701 0 12.6276 0 8.13506C0 3.64247 3.64247 0 8.13506 0C12.6276 0 16.2701 3.64247 16.2701 8.13506C16.2701 10.0242 15.6266 11.7625 14.5462 13.1432L14.5597 13.1249L20 18.5445L18.5557 19.9888L13.1361 14.5589L13.1257 14.5597ZM8.14299 14.2339C11.5129 14.2339 14.2443 11.5026 14.2443 8.13266C14.2443 4.76271 11.5129 2.03136 8.14299 2.03136C4.77304 2.03136 2.0417 4.76271 2.0417 8.13266C2.0417 11.5026 4.77304 14.2339 8.14299 14.2339Z" fill="currentcolor"/>
    </svg>
  );
};

export const TARGET = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z" fill="currentcolor"/>
      <path d="M11.1 0V1.9C6.2 2.3 2.4 6.2 1.9 11.1H0V12.9H1.9C2.3 17.8 6.2 21.6 11.1 22.1V24H12.9V22.1C17.8 21.7 21.6 17.8 22.1 12.9H24V11.1H22.1C21.7 6.2 17.8 2.4 12.9 1.9V0H11.1ZM11.1 3.7V5.5H12.9V3.7C16.8 4.1 19.8 7.2 20.2 11.1H18.4V12.9H20.2C19.8 16.8 16.7 19.8 12.9 20.3V18.5H11.1V20.3C7.2 19.9 4.2 16.8 3.8 12.9H5.6V11.1H3.8C4.2 7.2 7.2 4.1 11.1 3.7Z" fill="currentcolor"/>
    </svg>
  );
};

export const TICK = () => {
  return (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M14.681 0L5.24731 9.4L1.319 5.48571L0 6.8L4.58781 11.3714L5.24731 12L5.90681 11.3714L16 1.31429L14.681 0Z" fill="currentColor"/>
    </svg>
  );
};

export const ARROW_RIGHT = () => {
  return (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M12.5145 0.666656L20 8.15318L12.5145 15.6397L10.9496 14.0747L15.7553 9.26932L0 9.26975V7.03543L15.7547 7.03532L10.9496 2.23162L12.5145 0.666656Z" fill="currentColor"/>
    </svg>
  );
};

export const ARROW_COMPASS = () => {
  return (
    <svg
       width="23"
       height="20"
       viewBox="0 0 23 20"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
      <path
         d="M 6.5988792,1.7986196 1.5440328,13.286209 c -0.1941241,0.441167 0.2868078,0.874565 0.7053954,0.63578 l 4.46482,-2.547165 c 0.156534,-0.08934 0.349062,-0.08745 0.503836,0.0048 l 4.4148768,2.632672 c 0.413959,0.246899 0.903098,-0.177187 0.717565,-0.621901 L 7.5179832,1.807474 C 7.3487162,1.4017742 6.7759292,1.3962586 6.5988792,1.7986196 Z"
         fill="currentColor"
         id="path1057" />
      <path
         d="M 5.6835742,1.3958634 0.62875197,12.883496 c -0.5823357,1.323365 0.86041003,2.623473 2.11620953,1.906982 l 4.2114737,-2.402513 4.1643858,2.483308 c 1.241804,0.740507 2.709295,-0.531564 2.152562,-1.865974 L 8.4408762,1.4224316 c -0.50779,-1.21711793 -2.22615,-1.23366478 -2.757302,-0.026568 z"
         stroke="#ffffff"
         strokeWidth="2"
         id="path1059" />
    </svg>
  );
};

export const WARNING = () => {
  return (
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" d="M16 0A16.003 16.003 0 004.686 27.314a16.003 16.003 0 0022.628 0 16.003 16.003 0 000-22.628C24.313 1.686 20.244 0 16 0zm0 25a2 2 0 110-4.001A2 2 0 0116 25zm2-7h-4V7h4v11z"></path>
    </svg>
  );
};

export const CHEVRON = () => {
  return (
    <svg viewBox="0 0 20 32" id="chevron" xmlns="http://www.w3.org/2000/svg"><path d="M20 16L4 0 0 4l12 12L0 28l4 4 16-16z"/></svg>
  );
};